export default __webpack_public_path__ + "static/media/9.4d3cb923.png";